import React, { useEffect } from 'react'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import { useDispatch } from 'react-redux';
import { showLoader } from "../store/Slices/loaderSlice";
import { hidePageLoader } from "../utils/javascript";

export default function Layout({Page, children}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(showLoader());
    hidePageLoader(dispatch)
  }, [dispatch, Page]);
  return (
    <>
        <Header />
        <main>
          {Page? <Page /> : children}
        </main>
        <Footer />
      </>
  )
}
